import { render } from "./Social.vue?vue&type=template&id=21857510&scoped=true"
import script from "./Social.vue?vue&type=script&lang=js"
export * from "./Social.vue?vue&type=script&lang=js"

import "./Social.vue?vue&type=style&index=0&id=21857510&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21857510"],['__file',"webpack-assets/vue/templates/site/authorization/modal/Social.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21857510"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21857510', __exports__)) {
    api.reload('21857510', __exports__)
  }
  
  module.hot.accept("./Social.vue?vue&type=template&id=21857510&scoped=true", () => {
    api.rerender('21857510', render)
  })

}


export default __exports__